module.exports = __webpack_public_path__ + "img/xbox.ccd81ad0.png";